var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrdersIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 1.25024V2.75024C11.75 4.16424 11.75 4.87124 12.19 5.31024C12.628 5.75024 13.335 5.75024 14.75 5.75024H16.25",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 9.75024H12.75M4.75 12.7502H12.75M4.75 15.7502H8.92M0.75 14.7502V6.75024C0.75 3.92224 0.75 2.50724 1.629 1.62924C2.507 0.750244 3.922 0.750244 6.75 0.750244H10.922C11.33 0.750244 11.535 0.750244 11.719 0.826244C11.902 0.902244 12.047 1.04624 12.336 1.33624L16.164 5.16424C16.454 5.45424 16.598 5.59824 16.674 5.78224C16.75 5.96524 16.75 6.17024 16.75 6.57824V14.7502C16.75 17.5782 16.75 18.9932 15.871 19.8712C14.993 20.7502 13.578 20.7502 10.75 20.7502H6.75C3.922 20.7502 2.507 20.7502 1.629 19.8712C0.75 18.9932 0.75 17.5782 0.75 14.7502Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdersIcon);
export default __webpack_public_path__ + "static/media/orders-icon.2fb2aa1a28192c9f4ec0f3de983c6e49.svg";
export { ForwardRef as ReactComponent };